import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const QuotePaymentInput = () => {
  const { paymentId = '' } = useParams();
  const decodedId = paymentId ? atob(paymentId) : paymentId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'quotePayment';

  useEffect(() => {
    if (paymentId) { setIsEditing(true); fetchDetails(); }
  }, [paymentId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.quotePayment}${id}/`, { headers });
      setFormData({
        ...response.data,
        quote: response.data.quote?.id ?? response.data.quote,
      });
    } catch (error) {
      console.error('Error fetching payment details:', error);
    }
  };

  const fields = [
    {
      name: 'quote', label: 'Quote', type: 'async-select',
      endpoint: API_ROUTES.quote,
      getOptionLabel: (q) => q.title || `Quote #${q.id}`,
    },
    { name: 'payment_amount', label: 'Payment Amount', type: 'number' },
    { name: 'payment_date', label: 'Payment Date', type: 'date', dateConstraint: 'past' },
    {
      name: 'payment_method', label: 'Payment Method', type: 'select',
      options: [
        { value: 'bank_transfer', label: 'Bank Transfer' },
        { value: 'mpesa', label: 'M-Pesa' },
        { value: 'credit_card', label: 'Credit Card' },
        { value: 'cheque', label: 'Cheque' },
        { value: 'cash', label: 'Cash' },
        { value: 'paypal', label: 'PayPal' },
        { value: 'other', label: 'Other' },
      ],
    },
    {
      name: 'payment_status', label: 'Payment Status', type: 'select',
      options: [
        { value: 'pending', label: 'Pending' },
        { value: 'partial', label: 'Partial' },
        { value: 'completed', label: 'Completed' },
        { value: 'failed', label: 'Failed' },
        { value: 'refunded', label: 'Refunded' },
      ],
    },
    { name: 'reference', label: 'Reference', type: 'text' },
    { name: 'transaction_id', label: 'Transaction ID', type: 'text' },
    { name: 'notes', label: 'Notes', type: 'textarea' },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Quote Payment' : 'Create Quote Payment'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default QuotePaymentInput;
